import { useAuth0 } from "@auth0/auth0-react"
import React, { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Table } from "semantic-ui-react"
import BifrostTable from "../../../../Components/BifrostElementComponent/BifrostTable/BifrostTable"
import { useGetOrganizations } from "../../../../Hooks/FetchHooks/GetDataService/useGetOrganizations"
import userInfoContext from "../../../../store/userInfoContext"
import { isSuperAdminOrResellerAdmin, isSuperAdminOrResellerAdminOrAdmin } from "../../../../Utils/util"
import Error404 from "../../../OtherPages/ErrorPage/Error404"
import MainPanelFooter from "../../MainPanelFooter/MainPanelFooter"
import MainPanelHeader from "../../MainPanelHeader/MainPanelHeader"
import CreateOrganizationModal from "./OrganizationsModal/CreateOrganizationModal/CreateOrganizationModal"
import "./OrganizationsPage.scss"

const OrganizationsPage = () => {
	const nav = useNavigate()
	const { user } = useAuth0()
	const userInfo = useContext(userInfoContext)
	const { data: organizations, setData: setOrganizations, isLoading, getOrganizations } = useGetOrganizations()

	const columns = React.useMemo(() => {
		const superadminColumns = isSuperAdminOrResellerAdmin(user)
			? [
					{
						name: "Name",
						key: "name",
						type: "string"
					},
					{
						name: "Package",
						key: "package_name",
						type: "string"
					},
					{
						name: "Users",
						key: "no_users",
						type: "number"
					},
					{
						name: "Devices",
						key: "no_devices",
						type: "number"
					},
					{
						name: "Last Session (UTC)",
						key: "last_session",
						type: "number"
					}
			  ]
			: []

		return superadminColumns
	}, [user])

	const OrganizationRow = ({ item }) => (
		<Table.Row key={item.id} className={isSuperAdminOrResellerAdminOrAdmin(user) && "orgs-list-row"} onClick={() => nav(`/orgs/${item.id}`, { state: { name: item.name } })}>
			<Table.Cell>{item.name}</Table.Cell>
			<Table.Cell>{item.package_key ? <span className={`package-col-value ${item.package_key.toLowerCase()}`}>{item.package_name.toUpperCase()}</span> : "None"}</Table.Cell>
			<Table.Cell>{item.no_users}</Table.Cell>
			<Table.Cell>{item.no_devices}</Table.Cell>
			<Table.Cell>{item.last_session}</Table.Cell>
		</Table.Row>
	)

	const filterOrganization = (org, filter) => {
		if (!filter || filter === "") return true
		else return org.name.toLowerCase().includes(filter.toLowerCase())
	}

	useEffect(() => {
		userInfo && userInfo.terms_accepted && getOrganizations()
		return () => setOrganizations([])
	}, [])

	return !isSuperAdminOrResellerAdmin(user) ? (
		<Error404 />
	) : (
		<section className={"bifrost-table-panel users-table"}>
			<MainPanelHeader title={"Organizations"} fetchData={getOrganizations}>
				<div className="create-org-modal">
					<CreateOrganizationModal refreshOrgs={getOrganizations} />
				</div>
			</MainPanelHeader>
			<BifrostTable
				loading={isLoading}
				pageName="Organizations"
				columns={columns}
				data={organizations}
				Row={OrganizationRow}
				filterFunc={filterOrganization}
				defaultSort={{ order: "ascending", column: "last_session" }}
				isSelectable={!!(isSuperAdminOrResellerAdminOrAdmin(user) && !isLoading)}
				fetchData={getOrganizations}
			/>
			<MainPanelFooter />
		</section>
	)
}

export default OrganizationsPage
